import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import waterfall from 'vue-waterfall2';
import VueScrollLock from 'vue-scroll-lock';

import './assets/scss/reset.scss'; // 引入全局重置样式
import './assets/scss/layout.scss'; // 引入全局响应式布局
import utils from './plugins/utils.js'; // 引入全局函数
import './assets/scss/variables.scss'; //全局引入字体
import './assets/icon/iconfont.css';
import directives from './plugins/directives.js';

import { List } from 'vant';
Vue.use(List);

Vue.use(VueAxios, axios);
Vue.use(directives);
Vue.use(waterfall);
Vue.use(VueScrollLock);

Vue.config.productionTip = false;
Vue.prototype.$utils = utils;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
